import isDraftFilterAtLocation from "@qpr/client-api-base/attributes/drafts/disabledPages";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import defaultAttributes from "backend/defaultAttributes";
import { getChildHierarchy } from "backend/model/getChildHierarchy";
import { useQuery } from "react-query";
import usePeriodFromString from "../model/usePeriodFromString";
import usePeriodLevels from "../model/usePeriodLevels";

const useHierarchy = (
  id?: string,
  depth?: number,
  period?: string,
  disable?: boolean
) => {
  const ctx = useAppContext();
  const { data: periodLevels } = usePeriodLevels();

  const currentPeriod = usePeriodFromString(period);
  const usingPeriod = currentPeriod?.name || "";

  return useQuery(
    `data-children-${id}-${usingPeriod}-${depth}-${isDraftFilterAtLocation()}`,
    () =>
      getChildHierarchy(
        id || "",
        (q) =>
          q.attributes(
            ...defaultAttributes(currentPeriod?.name, periodLevels!!)
          ),
        depth || 10,
        currentPeriod!,
        periodLevels!
      ),
    {
      enabled: !!id && !!currentPeriod && !!periodLevels && !disable,
      cacheTime: 1,
      staleTime: 1,
    }
  );
};

export default useHierarchy;
